import { initLocalOptionsWithDefaultOption } from '../Selectors/Option';

export const colors = initLocalOptionsWithDefaultOption([
  {
    value: '#A5A5A5',
    title: 'RAL 9006 - Weiß-Aluminium',
    externalIdentifier: 'ral_9006',
  },
]);

export const defaultColor = colors[1];
